import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/option'

import component from 'components/Options/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => ({
  option: state.option
})

const form = reduxForm({
  form: 'edit-option',
  fields: ['id', 'name'], // NOTE: id can't be updated, just used to send to API
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
}, state => ({
  initialValues: state.option
}))(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Options/containers/EditOptionContainer.js